(function (root) {
  if (!root || !root.document) return;

  var STORAGE_KEY = 'cm_rastreio_v1';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK_KEYS = ['gclid', 'wbraid', 'gbraid'];

  function readStorage() {
    try {
      var raw = root.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeStorage(data) {
    try {
      root.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      // armazenamento indisponível: a coleta segue só com o que está na URL atual
    }
  }

  function readCookie(name) {
    var escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    var match = root.document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function persistArrival() {
    var params = new URLSearchParams(root.location.search);
    var stored = readStorage();
    var changed = false;

    UTM_KEYS.concat(CLICK_KEYS).concat(['fbclid']).forEach(function (key) {
      var value = params.get(key);
      if (value) {
        if (key === 'fbclid' && stored.fbclid !== value) {
          stored.fbclid_at = Date.now();
        }
        stored[key] = value;
        changed = true;
      }
    });

    if (changed) writeStorage(stored);
    return stored;
  }

  function getGaClientId() {
    var ga = readCookie('_ga');
    if (!ga) return '';
    var parts = ga.split('.');
    if (parts.length < 4) return '';
    return parts.slice(-2).join('.');
  }

  function getGaSessionId() {
    var cookies = root.document.cookie ? root.document.cookie.split(';') : [];
    var i;
    for (i = 0; i < cookies.length; i += 1) {
      var part = cookies[i].replace(/^\s+/, '');
      if (part.indexOf('_ga_') !== 0) continue;
      var value = decodeURIComponent(part.split('=').slice(1).join('='));
      var bits = value.split('.');
      if (bits.length >= 3 && /^\d+$/.test(bits[2])) return bits[2];
    }
    return '';
  }

  function getFbc(stored) {
    var cookie = readCookie('_fbc');
    if (cookie) return cookie;
    if (!stored.fbclid) return '';
    return 'fb.1.' + (stored.fbclid_at || Date.now()) + '.' + stored.fbclid;
  }

  function coletar() {
    var stored = persistArrival();
    var result = {
      page_url: root.location.href,
      fbp: readCookie('_fbp') || null,
      fbc: getFbc(stored) || null,
      fbclid: stored.fbclid || null,
      ga_client_id: getGaClientId() || null,
      ga_session_id: getGaSessionId() || null
    };

    UTM_KEYS.concat(CLICK_KEYS).forEach(function (key) {
      if (stored[key]) result[key] = stored[key];
    });

    return result;
  }

  persistArrival();

  root.CheckMotorsRastreio = {
    coletar: coletar
  };
})(typeof window !== 'undefined' ? window : undefined);
